define('modules/form_editor/views/code_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/code_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view");

  var escapeHtml = function(html) {
    return html.replace(/</g, "&lt;").replace(/&/g, "&amp;");
  };

  var unescapeHtml = function(html) {
    return html.replace(/&lt;/g, "<").replace(/&amp;/g, "&").replace();
  };

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/code_popup"),
    triggers: {
      "click .js-cancel": "cancel",
      "click .close": "cancel",
      "click .js-save": "save"
    },
    onRender: function(){
      this.$el.i18n();
    },
    helpers: function() {
      var json = this.model.toJSON(),
          modelString = JSON.stringify(json).trim();
      return {
        serializedModel: escapeHtml(modelString)
      };
    }
  },{
    show: function(oldModel, data) {
      var popup = new module.exports({model: oldModel}),
          defer = $.Deferred();
      if(data.error) {
        popup.$el.find(".js-error").show();
      }
      popup.$el.find('textarea').select();
      popup.on("save", function() {
        var newModelString = this.$el.find('textarea').val();
        defer.resolve(unescapeHtml(newModelString));
      });
      popup.on("cancel hide", defer.reject, defer);
      popup.on("save cancel", popup.hide, popup);
      return defer.promise();
    }
  });

});

